/*
 *   File : cancel-sip.js
 *   Author URI : https://evoqins.com
 *   Description : Confirmation UI to be shown before Cancelling an active SIP.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect } from "react";

import { GradientButton, OutlineButton } from "../Cta";
import Icon from "../Icon/icon";

import style from "../../Styles/Components/cancel-sip.module.scss"

const CancelSIPModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("cancel-sip");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    return (
        <div className={`modal fade ${style.e_sip_modal}`}
            id="cancel-sip"
            tabIndex="-1"
            aria-labelledby="cancel-sip"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content  padding-32px-lr pb-3 ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_close}`} />
                    <div className="text-center">
                        <img draggable={false} src={require("../../Assets/Images/Modal/cancel-sip-delete.png")}
                            alt="Delete SIP"
                            width={72}
                            height={72} />
                    </div>
                    <p className="color-eerie-black e-poppins-medium e-font-18 mb-3 mt-4">Are you sure you want to cancel your SIP?</p>

                    <div className="position-relative border-radius-8px bg-antique-white p-2 ps-3">
                        <div className={`bg-chinese-orange position-absolute top-0 left-0 h-100 ${style.e_warning}`}>

                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <img draggable={false} src={require("../../Assets/Images/Modal/danger-triangle.png")}
                                alt="Danger"
                                width={24}
                                height={24} />
                            <p className="color-kenyan-copper e-poppins-semi-bold e-font-12 mb-0 ms-1">Warning</p>
                        </div>
                        <p className="color-medium-carmine e-poppins-medium e-font-12 mb-0">Cancelling SIP will affect your portfolio.</p>
                    </div>

                    <div className="mt-4 d-flex justify-content-center gap-8px">
                        <OutlineButton label="Cancel"
                            cancel="modal"
                            className="e-font-16 e-poppins-regular px-4 padding-12px-tb" />
                        <GradientButton label="Yes, Cancel SIP"
                            cancel="modal"
                            className="e-font-16 px-3 padding-12px-tb"
                            onPress={props.cancel} />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CancelSIPModal